export default __webpack_public_path__ + "alberta-return-delivery.dd75be2db331db59df50.svg";